import { z } from 'zod';
// Sdílené kontroly volných textových vstupů (FR01 20261024_BezpAudit_NIS2_Opravy/003_Payments, FR-01).
// Znaky se kontrolují po jednom, ne regexem - regulární výraz s řídicími znaky hlásí eslint pravidlo
// no-control-regex.
export const SINGLE_LINE_TEXT_MESSAGE = 'Text nesmí obsahovat konce řádků ani řídicí znaky.';
/**
 * Řídicí znaky včetně konců řádku (CR, LF, NEL, LS, PS) a tabulátoru. Jednořádkový text může skončit v
 * hlavičce e-mailu (předmět, jméno), kde by konec řádku byl pokus o vložení další hlavičky.
 */
export function hasControlOrLineBreak(value) {
    for (const char of value) {
        const code = char.charCodeAt(0);
        if (code < 0x20 || code === 0x7f || code === 0x85 || code === 0x2028 || code === 0x2029)
            return true;
    }
    return false;
}
/**
 * Víceřádkový text (poznámka): povolené jsou jen konce řádku a tabulátor (`\n`, `\r`, `\t`), ostatní
 * řídicí znaky ASCII (< 0x20 a 0x7F) ne.
 */
export function hasDisallowedMultilineControl(value) {
    for (const char of value) {
        const code = char.charCodeAt(0);
        if (code === 0x09 || code === 0x0a || code === 0x0d)
            continue;
        if (code < 0x20 || code === 0x7f)
            return true;
    }
    return false;
}
/** Jednořádkový text: kontrola řídicích znaků nad původní hodnotou, povinnost a délka nad oříznutou. */
export function singleLineText(requiredMessage, maxLength, tooLongMessage, singleLineMessage = SINGLE_LINE_TEXT_MESSAGE) {
    return z
        .string({ required_error: requiredMessage, invalid_type_error: requiredMessage })
        .refine((value) => !hasControlOrLineBreak(value), singleLineMessage)
        .transform((value) => value.trim())
        .pipe(z.string().min(1, requiredMessage).max(maxLength, tooLongMessage));
}
